import React from "react";
import { FaRegImages } from "react-icons/fa";

const CommentModal = ({ show, setShow }) => {
  return (
    <>
      {show && (
        <div className="comment-modal-overlay">
          <div className="comment-modal-container">
            <div className="comment-modal-header">
              <button
                className="comment-close-btn"
                onClick={() => setShow(false)}
              >
                ✖
              </button>

              <div className="comment-head">
                {" "}
                <h3>Comment</h3>
              </div>
            </div>
            <textarea
              className="comment-input"
              placeholder="Comment"
              rows="4"
            ></textarea>
            <div className="comment-file-upload">
              <div className="comment-drag-drop">
                <div className="icon-source">
                  {" "}
                  <FaRegImages style={{ height: "30px", width: "30px" }} />
                </div>
                <span>Drag and Drop Image</span>
                <br></br>
                <small>(Optional)</small>
              </div>
              <div className="measure">
                <label className="comment-choose-file">
                  <input type="file" className="comment-file-input" />
                  Choose File
                </label>

                <div className="comment-file-name"></div>
                <div className="file-name"> No File Chosen</div>
              </div>
            </div>
            <button className="comment-reply-btn">Reply Post</button>
          </div>
        </div>
      )}
    </>
  );
};

export default CommentModal;
